// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_healthgenom_container__2ie74","selected":"CheckBox_healthgenom_selected__1SwRP","customSizeSpan":"CheckBox_healthgenom_customSizeSpan__2l3_j"};